import Skeleton from 'react-loading-skeleton';
import './tasksSkeleton.scss';

const LIST_ROWS = 8;
const GRID_ROWS = 9;

// widths of the classic row's columns, so the placeholders sit where the real text will
const LIST_COLUMNS = ['20%', '30%', '15%', '10%', '10%'];

// placeholder task cards for the classic list, rendered inside its own task-list-content
export const TaskListSkeletonRows = () => (
    <>
        {Array.from({length: LIST_ROWS}, (_, row) => (
            <li key={row} className="col-md-12 container list-group-item banner-list tasks-skeleton__card"
                aria-hidden="true" data-testid="tasks-skeleton-row">
                <Skeleton width={16} height={16}/>
                <Skeleton width={24} height={24}/>
                {LIST_COLUMNS.map((width, column) => (
                    <span key={column} style={{width}}><Skeleton/></span>
                ))}
            </li>
        ))}
    </>
);

// placeholder for the overview grid, sized to its rows rather than the grid's full height
export const TasksGridSkeleton = () => (
    <div className="tasks-skeleton__grid" aria-hidden="true" data-testid="tasks-grid-skeleton">
        <div className="tasks-skeleton__grid-header">
            <Skeleton width={16} height={16}/>
            <span className="aw:w-1/4"><Skeleton/></span>
            <span className="aw:w-1/4"><Skeleton/></span>
            <span className="aw:w-1/6"><Skeleton/></span>
        </div>
        {Array.from({length: GRID_ROWS}, (_, row) => (
            <div key={row} className="tasks-skeleton__grid-row" data-testid="tasks-skeleton-row">
                <Skeleton width={16} height={16}/>
                <span className="aw:w-1/4"><Skeleton/></span>
                <span className="aw:w-1/3"><Skeleton/></span>
                <span className="aw:w-1/6"><Skeleton/></span>
                <span className="aw:w-1/12"><Skeleton/></span>
            </div>
        ))}
    </div>
);
